import { useRouter } from 'next/router';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { PostContext } from '../../../../../context/PostContext';
import styles from './BlogBodyUI.module.css';
import ExpiredRecruitDate from './ExpiredRecruitDate';
import HashTags from './Hashtag';
import { PStyled } from './PostBodyUI';

const BlogBodyUI = () => {
  const { content, title, isLocked } = useContext(PostContext);
  const router = useRouter();
  const { pid } = router.query;
  const contentRef = useRef<HTMLParagraphElement>(null);

  const [maxHeight, setMaxHeight] = useState<number>(0);

  // Calculate max height of post content
  // Each (line of text) or (gap between paragraphs) is:
  // line height = 1.4 rem = 1.4 * font size
  // Set maxHeight to be 3*(line height)
  useEffect(() => {
    if (!contentRef.current) return;
    const linesAllowed = isLocked ? 0 : 3;
    setMaxHeight(
      parseFloat(getComputedStyle(contentRef.current).fontSize) *
        1.4 *
        linesAllowed
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef.current]);

  // check to see if the content is line-clamped
  // i.e if the content is line-clamped, there is more text to be shown
  // use this to render "Xem thêm..." button
  const isClamped = useMemo(() => {
    return (contentRef.current?.scrollHeight as number) > maxHeight;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef.current, maxHeight]);

  // eslint-disable-next-line react/no-unstable-nested-components
  const Title = () => (
    <h1 className="mb-1 text-xl font-bold leading-[30px] tracking-[-0.025em] text-[#242424] break-word-legacy">
      {title}
    </h1>
  );

  return (
    <div>
      {!pid ? (
        <>
          <ExpiredRecruitDate />
          <HashTags />
          <Title />
          {!isLocked && (
            <>
              <PStyled
                dangerouslySetInnerHTML={{
                  __html: content.replace(/<img .*?>/g, ''),
                }}
                ref={contentRef}
                style={{
                  maxHeight: maxHeight,
                  overflowY: 'hidden',
                }}
                className={`${styles.BlogBodyUI} break-words text-base font-medium leading-[1] tracking-[-0.0125em] [&>*]:!whitespace-normal`}
              ></PStyled>
              {isClamped ? (
                <>
                  <span>... </span>
                  <span className="cursor-pointer text-sm font-semibold leading-4 tracking-[-0.1px] text-Primary/Main hover:underline">
                    Xem thêm
                  </span>
                </>
              ) : null}
            </>
          )}
        </>
      ) : (
        <>
          <ExpiredRecruitDate />
          <Title />
          {!isLocked && (
            <div
              dangerouslySetInnerHTML={{
                __html: content,
              }}
              className={`${styles.BlogBodyUI} break-words text-base font-medium leading-[1] tracking-[-0.0125em] [&>*]:!whitespace-normal`}
            />
          )}
          <HashTags />
        </>
      )}
    </div>
  );
};

export default BlogBodyUI;
